import type { InferOutput } from "valibot";
import { type Options, useMutation } from "../useMutation";
import { type RequestProgramFITInputSchema, RequestProgramFITOutputSchema } from "./schemaTypes";

export const useRequestProgramFITMutation = (options?: Options<InferOutput<RequestProgramFITOutputSchema>>) => {
  return useMutation<RequestProgramFITInputSchema, RequestProgramFITOutputSchema>(
    "/api/request-program-fit/",
    RequestProgramFITOutputSchema,
    options,
  );
};
